class AudioPlayer {
    constructor(audioId, playButtonSelector, pauseButtonSelector, progressBarSelector, timelineSelector, timeDisplaySelector, muteButtonSelector, volumeSliderSelector, fastForwardButtonSelector, rewindButtonSelector) {
        this.audio = document.getElementById(audioId);
        this.playButton = document.querySelector(playButtonSelector);
        this.pauseButton = document.querySelector(pauseButtonSelector);
        this.progressBar = document.querySelector(progressBarSelector);
        this.timeline = document.querySelector(timelineSelector);
        this.timeDisplay = document.querySelector(timeDisplaySelector);
        this.muteButton = document.querySelector(muteButtonSelector);
        this.volumeSlider = document.querySelector(volumeSliderSelector);
        this.fastForwardButton = document.querySelector(fastForwardButtonSelector);
        this.rewindButton = document.querySelector(rewindButtonSelector);
        this.minutesDisplay = document.querySelector('.audio-player-minutes');
        this.loggedSpeechHistory = false;
        this.init();
    }

    init() {
        // Événements de contrôle
        this.playButton.addEventListener('click', () => this.togglePlay());
        this.audio.addEventListener('timeupdate', () => this.updateProgress());
        this.timeline.addEventListener('click', (event) => this.seek(event));
        this.muteButton.addEventListener('click', () => this.toggleMute());
        this.volumeSlider.addEventListener('input', () => this.updateVolume());
        this.fastForwardButton.addEventListener('click', () => this.fastForward());
        this.rewindButton.addEventListener('click', () => this.rewind());
        // Remettre le bouton en mode "Play" à la fin de la lecture
        this.audio.addEventListener('ended', () => this.resetPlayButton());
        // Afficher le temps total lorsque les métadonnées de l'audio sont chargées
        this.audio.addEventListener('loadedmetadata', () => {
            this.updateTimeDisplay();
            this.updateMinutesDisplay();
        });
    }

    togglePlay() {
        const playIcon = this.playButton.querySelector('i');
        if (this.audio.paused) {
            this.audio.play();
            playIcon.classList.remove('fa-play');
            playIcon.classList.add('fa-pause');
            if (this.audio.dataset.logId && this.audio.dataset.logTitle && !this.loggedSpeechHistory) {
                this.logSpeechHistory();
                this.loggedSpeechHistory = true;
            }
        } else {
            this.audio.pause();
            playIcon.classList.remove('fa-pause');
            playIcon.classList.add('fa-play');
        }
    }

    updateProgress() {
        const progress = (this.audio.currentTime / this.audio.duration) * 100;
        this.progressBar.style.width = `${progress}%`;
        this.updateTimeDisplay();
    }

    updateTimeDisplay() {
        const currentTime = this.formatTime(this.audio.currentTime);
        const duration = this.formatTime(this.audio.duration);
        this.timeDisplay.textContent = `${currentTime} / ${duration}`;
    }

    updateMinutesDisplay() {
        const ceilMinutes = Math.floor(this.audio.duration / 60);
        const minuteLabel = ceilMinutes <= 1 ? "minute" : "minutes";
        this.minutesDisplay.textContent = `${ceilMinutes} ${minuteLabel}`;
    }

    formatTime(time) {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60).toString().padStart(2, "0");
        return `${minutes}:${seconds}`;
    }

    seek(event) {
        const clickPosition = (event.offsetX / this.timeline.clientWidth) * this.audio.duration;
        this.audio.currentTime = clickPosition;
    }

    toggleMute() {
        this.audio.muted = !this.audio.muted;
        this.muteButton.innerHTML = this.audio.muted ? '<i class="fas fa-volume-mute"></i>' : '<i class="fas fa-volume-up"></i>';
    }

    updateVolume() {
        this.audio.volume = this.volumeSlider.value;
    }

    fastForward() {
        this.audio.currentTime += 10; // Avancer de 10 secondes
    }

    rewind() {
        this.audio.currentTime -= 10; // Reculer de 10 secondes
    }

    resetPlayButton() {
        const playIcon = this.playButton.querySelector('i');
        playIcon.classList.remove('fa-pause');
        playIcon.classList.add('fa-play');
    }

    logSpeechHistory() {
        fetch('/log_speech_history_api', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                articleTitle: this.audio.dataset.logTitle,
                articleId: this.audio.dataset.logId
            })
        })
            .then(response => {
                if (response.ok) {
                    console.log('Speech history saved');
                } else {
                    console.error('Error saving speech history');
                }
            })
            .catch(error => {
                console.error('Network error:', error);
            });
    }
}

// Initialiser le lecteur audio si le DOM contient la classe 'audio-player'
document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector('.audio-player')) {
        const player = new AudioPlayer(
            "audio",
            ".audio-player__play-button",
            ".audio-player__pause-button",
            ".audio-player__progress-bar",
            ".audio-player__timeline",
            ".audio-player__time-display",
            ".audio-player__mute-button",
            ".audio-player__volume-slider",
            ".audio-player__fast-forward-button",
            ".audio-player__rewind-button"
        );
    }
});
